import styled from 'styled-components';

const EmptyFieldWrapper = styled.span`
  font-style: italic;
  color: #5e5e5e;
`;

export { EmptyFieldWrapper };
